module.exports = __webpack_public_path__ + "static/img/2_2_1.d710c5f4.jpg";